import React from 'react';
import {Helmet} from 'react-helmet-async';

interface JsonLdProps {
  /** 结构化数据对象（或数组），序列化后经 Helmet 注入 <head>；全站 Organization/WebSite 数据在 public/index.html */
  data: Record<string, unknown> | Record<string, unknown>[];
}

/** 页面级 JSON-LD 结构化数据注入（产品页用法见 buildProductJsonLd） */
const JsonLd: React.FC<JsonLdProps> = ({data}) => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(data)}</script>
  </Helmet>
);

export interface ProductJsonLdParams {
  /** 面包屑首页文案（t('common:nav.homeAria')） */
  homeLabel: string;
  /** 站内路由，以 / 开头、不含 /home 前缀（如 /image-translator） */
  path: string;
  /** 产品描述（t() 后的文案） */
  productDescription: string;
  /** 产品名（t() 后的文案） */
  productName: string;
}

const SITE_URL = 'https://www.xiangjifanyi.com/home/';

/** 产品落地页结构化数据：SoftwareApplication（富摘要）+ BreadcrumbList（面包屑） */
export const buildProductJsonLd = ({homeLabel, path, productDescription, productName}: ProductJsonLdParams) => [
  {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    applicationCategory: 'BusinessApplication',
    description: productDescription,
    name: productName,
    offers: {'@type': 'Offer', price: '0', priceCurrency: 'CNY'},
    operatingSystem: 'Web',
    publisher: {'@id': `${SITE_URL}#organization`},
    url: `${SITE_URL}${path.slice(1)}`,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {'@type': 'ListItem', item: SITE_URL, name: homeLabel, position: 1},
      {'@type': 'ListItem', item: `${SITE_URL}${path.slice(1)}`, name: productName, position: 2},
    ],
  },
];

export default JsonLd;
